import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    flexContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      width: '100%',
      gap: '0px',
      maxWidth: '100%',
      overflow: 'hidden',
      paddingLeft: 0,
      marginBottom: '8px',
    },
    grab: {
      cursor: 'move',
      flexShrink: 0,
      padding: 0,
      minWidth: '32px',
      width: '32px',
      height: '32px',
      margin: 0,
      marginRight: '8px',
      alignSelf: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': {
        fontSize: '20px',
      },
    },
    root: {
      width: '100%',
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      maxWidth: 'calc(100% - 40px)',
    },
    accordionSummary: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      minHeight: '48px',
      padding: '0 16px',
      backgroundColor: '#fff',
      border: '1px solid #CDCEDA',
      borderRadius: '4px',
      boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)',
    },

    summaryText: {
      flex: 1,
      marginRight: '16px',
    },
    summaryTextH6: {
      fontSize: 14,
      fontFamily: 'Poppins',
      fontWeight: 500,
      color: '#000A8C',
    },
    accordionFlexContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
    },
    iconButton: {
      padding: 5,
    },
  })
);

export default useStyles; 